import React, { useMemo } from "react";
import { getGatsbyImageData } from "gatsby-source-sanity";
import { GatsbyImage } from "gatsby-plugin-image";
import { SANITY_STUDIO_PROJECT_ID, SANITY_STUDIO_DATASET } from "utils/constants";
import Link from "components/link";

const getGatsbyImage = (img, width) => {
	return getGatsbyImageData(
		img,
		{ width: width || 1920 },
		{
			projectId: SANITY_STUDIO_PROJECT_ID,
			dataset: SANITY_STUDIO_DATASET
		}
	);
};

const Image = ({ image, width, className, alt, fetchpriority, ...other }) => {

	if (!image?.asset && !image?._ref) {
		// If no actual image is provided, use a placeholder image
		const placeholderImageId = "image-1144e50d6c122b795a0333b0172ed26cb2b46a0b-800x800-png";
		return (
			<GatsbyImage
				image={getGatsbyImage({ _ref: placeholderImageId }, width)}
				alt={alt ?? image?.alt ?? ""}
				className={className}
				{...other}
			/>
		);
	}

	const memoizedImage = useMemo(() => (
		<GatsbyImage
			image={getGatsbyImage(image, width)}
			alt={alt ?? image?.alt ?? ""}
			className={className}
			fetchpriority={fetchpriority || "auto"}
			{...other}
		/>
	), [image, width, className, alt]);

	return (
		image.url ?
			<Link to={image.url} className={className} isTargetBlank={image.isTargetBlank} {...other}>
				{memoizedImage}
			</Link> :
			memoizedImage
	);
};

export default Image;